@for (row of model(); track row; let i = $index) {
    <div class="st-special-row">
        @for (col of columns(); track col; let j = $index) {
            @if (col.validation.toUpperCase() === 'TEXT' || col.validation.toUpperCase() === 'TIME' || col.validation.toUpperCase() === 'MOSDATETIME' || col.validation.toUpperCase() === 'DURATION') {
                <st-text-field
                    class="st-special-row__text-field"
                    subscriptSizing="dynamic"
                    [value]="getValue(i, j)"
                    [label]="col.header"
                    [disabled]="disabled()"
                    (changed)="valueChanged($event, i, j)" />
            } @else if (col.validation.toUpperCase() === 'COMBOBOX') {
                <st-combo-box
                    subscriptSizing="dynamic"
                    class="st-special-row__combo-box"
                    [itemList]="col.list"
                    [label]="col.header"
                    [disabled]="disabled()"
                    [value]="getValue(i, j)"
                    (changed)="valueChanged($event, i, j)" />
            }
        }
    </div>
}
